import { useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import { SUMMARY_BUILDERS } from './helper';
import Summary from './Summary';

const Gate = ({ stepId, children }) => {
  const { sectionData, completion, mergeSection }: any = useOutletContext() || {};
  const [isEditing, setIsEditing] = useState(false);

  const isCompleted = !!completion?.[stepId];

  if (SUMMARY_BUILDERS[stepId] && isCompleted && !isEditing)
    return (
      <Summary
        stepId={stepId}
        data={sectionData?.[stepId]}
        onEdit={() => setIsEditing(true)}
      />
    );

  if (!isEditing) return children({});

  return children({
    editMode: true,
    onCancel: () => setIsEditing(false),
    onSaved: (data) => {
      mergeSection(stepId, data);
      setIsEditing(false);
    },
  });
};

export default Gate;
